import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FILE_STORAGE } from "../domain";

import { roleGuard } from "@api";
import { fileApi } from "@api/services";

export const ACTION_DOWNLOAD_FILE = "DOWNLOAD_FILE";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const deleteFileAsync = async (filePath: string): Promise<void> => {
  const response = await fileApi.fileStorageControllerDeleteFile(filePath);

  return response.data;
};

export const useDeleteFile = (
  user: UserProfileDto | null,
): {
  deleteFileAsync: UseMutateAsyncFunction<void, Error, string, unknown>;
  deleteFileEnabled: boolean;
  isSuccessDeleteFile: boolean;
  isPendingDeleteFile: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILE_STORAGE, ACTION_DOWNLOAD_FILE],
    mutationFn: enabled ? deleteFileAsync : undefined,
  });

  return {
    deleteFileAsync: mutateAsync,
    deleteFileEnabled: enabled,
    isSuccessDeleteFile: isSuccess,
    isPendingDeleteFile: isPending,
  };
};
